module.exports = __webpack_public_path__ + "img/curved26.56949acf.jpeg";